export const UPCOMING_MATCH = "UPCOMING_MATCH";
export const LIVE_MATCH = "LIVE_MATCH";
export const MATCH_INFO = "MATCH_INFO";
export const RECENT_MATCH = "RECENT_MATCH";
export const SERIES_LIST = "SERIES_LIST";
export const HOME_LIST = "HOME_LIST";
export const PLAYER_RANKING = "PLAYER_RANKING";
export const LOADING = "LOADING";
export const FETCH_ERROR = "FETCH_ERROR ";
// Player Information API POST
export const FETCH_PLAYER_INFO_REQUEST = "FETCH_PLAYER_INFO_REQUEST";
export const FETCH_PLAYER_INFO_SUCCESS = "FETCH_PLAYER_INFO_SUCCESS";
export const FETCH_PLAYER_INFO_FAILURE = "FETCH_PLAYER_INFO_FAILURE";
